import { useCallback, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import authProvider from '@utils/auth/createAuthProvider';
import getSocket from '@api/getSocket';
import mapVehicleDataSocketToDB from '@utils/middlewares/mapVehicleDataSocketToDB';
import socketActions from '@state/socket/actions';

let socket = null;

function useSocket() {

  const dispatch = useDispatch();
  const isLogged = useSelector(({ user }) => user.isLogged);
  const clientTarget = useSelector(({ user }) => user.clientTarget);
  const attempts = useRef(0);

  const socketDisconnect = useCallback(() => {

    if (socket) socket.disconnect();

  }, []);

  const socketEvents = useCallback(
    async () => {

      const { id } = clientTarget;
      const room = `cid_${id}`;
      const jwt = await authProvider.getToken();
      const auth = { room, jwt };

      socket.emit('join', auth);

      socket.on('message-room', (data) => {

        let jsonData;
        try {

          jsonData = JSON.parse(data);

        } catch (error) {

          return;

        }

        const values = mapVehicleDataSocketToDB(jsonData);
        const { license_plate } = values;
        dispatch(socketActions.updateVehicle({ license_plate, values }));

      });

      socket.on('disconnect', () => {

        if (socket) socket.disconnect();
        socket = null;

      });

      socket.on('connect_error', (error) => {

        attempts.current += 1;
        if (attempts.current >= 3) socketDisconnect();
        // timeout.current = setTimeout(socketEvents, 1500);

      });

    },
    // eslint-disable-next-line
    [clientTarget, isLogged]
  );

  const connectSocket = useCallback(
    () => {

      if (!clientTarget || !isLogged || socket !== null) return;

      socket = getSocket();
      socketEvents();

    },
    // eslint-disable-next-line
    [isLogged, clientTarget]
  );

  return { connectSocket, socketDisconnect };

}

export default useSocket;
